import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const SesameIcon = ({
  innerColor = '#fefefe',
  outerColor = '#a89a7b',
  ...props
}: AllergnIconProps) => {
  return (
    <SvgWrapper {...props}>
      <g id="Grupo_127" data-name="Grupo 127" transform="translate(16 -2094)">
        <g
          id="Rectángulo_12"
          data-name="Rectángulo 12"
          transform="translate(-16 2094)"
          fill="none"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="sesame" transform="translate(-9 2099)">
          <g
            id="Grupo_104"
            data-name="Grupo 104"
            transform="translate(1.405 9.481)"
          >
            <g id="Grupo_103" data-name="Grupo 103">
              <path
                id="Trazado_9105"
                data-name="Trazado 9105"
                d="M96,313.95a3.538,3.538,0,0,0-1.031-.868.309.309,0,0,0-.274,0,3.539,3.539,0,0,0-1.031.868,4.511,4.511,0,0,0-1,2.955,2.109,2.109,0,0,0,.662,1.769,3.034,3.034,0,0,0,3.015,0A2.109,2.109,0,0,0,97,316.9,4.511,4.511,0,0,0,96,313.95Zm-.044,4.239a2.495,2.495,0,0,1-2.248,0,1.557,1.557,0,0,1-.428-1.284,3.891,3.891,0,0,1,.84-2.537,3.251,3.251,0,0,1,.712-.65,3.25,3.25,0,0,1,.712.65,3.891,3.891,0,0,1,.84,2.537A1.557,1.557,0,0,1,95.952,318.189Z"
                transform="translate(-92.658 -313.05)"
              />
            </g>
          </g>
          <g
            id="Grupo_106"
            data-name="Grupo 106"
            transform="translate(0 3.301)"
          >
            <g id="Grupo_105" data-name="Grupo 105">
              <path
                id="Trazado_9106"
                data-name="Trazado 9106"
                d="M52.274,111.025a3.537,3.537,0,0,0-.868-1.031,4.511,4.511,0,0,0-2.955-1,2.109,2.109,0,0,0-1.769.662,3.034,3.034,0,0,0,0,3.015,2.109,2.109,0,0,0,1.769.662,4.511,4.511,0,0,0,2.955-1,3.538,3.538,0,0,0,.868-1.031A.309.309,0,0,0,52.274,111.025Zm-1.286.849a3.89,3.89,0,0,1-2.537.84,1.557,1.557,0,0,1-1.284-.428,2.494,2.494,0,0,1,0-2.248,1.557,1.557,0,0,1,1.284-.428,3.89,3.89,0,0,1,2.537.84,3.252,3.252,0,0,1,.65.712A3.25,3.25,0,0,1,50.988,111.874Z"
                transform="translate(-46.281 -108.992)"
              />
            </g>
          </g>
          <g
            id="Grupo_108"
            data-name="Grupo 108"
            transform="translate(7.444 0)"
          >
            <g id="Grupo_107" data-name="Grupo 107">
              <path
                id="Trazado_9107"
                data-name="Trazado 9107"
                d="M297.316,3.59a4.512,4.512,0,0,0-1.381-2.8A2.109,2.109,0,0,0,294.216.01a2.4,2.4,0,0,0-1.35.782,2.394,2.394,0,0,0-.782,1.35,2.109,2.109,0,0,0,.782,1.719,4.511,4.511,0,0,0,2.8,1.381c.129.012.252.017.366.017a3.3,3.3,0,0,0,.976-.132.309.309,0,0,0,.194-.194A3.54,3.54,0,0,0,297.316,3.59Zm-.662.99a3.249,3.249,0,0,1-.963.044,3.89,3.89,0,0,1-2.388-1.2,1.557,1.557,0,0,1-.606-1.211,1.768,1.768,0,0,1,.606-.984,1.768,1.768,0,0,1,.984-.606.843.843,0,0,1,.1-.006,1.681,1.681,0,0,1,1.114.611,3.891,3.891,0,0,1,1.2,2.388A3.25,3.25,0,0,1,296.655,4.58Z"
                transform="translate(-292.074 0)"
              />
            </g>
          </g>
          <g
            id="Grupo_110"
            data-name="Grupo 110"
            transform="translate(6.946 7.374)"
          >
            <g id="Grupo_109" data-name="Grupo 109">
              <path
                id="Trazado_9108"
                data-name="Trazado 9108"
                d="M280.118,244.885a4.511,4.511,0,0,0-2.8-1.381,3.538,3.538,0,0,0-1.343.115.309.309,0,0,0-.194.194,3.538,3.538,0,0,0-.115,1.343,4.511,4.511,0,0,0,1.381,2.8,2.239,2.239,0,0,0,1.546.792,1.489,1.489,0,0,0,.173-.01A3.034,3.034,0,0,0,280.9,246.6,2.109,2.109,0,0,0,280.118,244.885Zm.169,1.648a2.494,2.494,0,0,1-1.59,1.59,1.557,1.557,0,0,1-1.211-.606,3.891,3.891,0,0,1-1.2-2.388,3.251,3.251,0,0,1,.044-.963,3.672,3.672,0,0,1,3.351,1.157A1.557,1.557,0,0,1,280.286,246.533Z"
                transform="translate(-275.651 -243.488)"
              />
            </g>
          </g>
          <g
            id="Grupo_112"
            data-name="Grupo 112"
            transform="translate(8.88 10.659)"
          >
            <g id="Grupo_111" data-name="Grupo 111">
              <path
                id="Trazado_9109"
                data-name="Trazado 9109"
                d="M340.07,352.114l-.052-.05a.309.309,0,0,0-.437.437l.07.067a.309.309,0,0,0,.42-.454Z"
                transform="translate(-339.49 -351.973)"
              />
            </g>
          </g>
          <g
            id="Grupo_114"
            data-name="Grupo 114"
            transform="translate(9.749 10.659)"
          >
            <g id="Grupo_113" data-name="Grupo 113">
              <path
                id="Trazado_9110"
                data-name="Trazado 9110"
                d="M369.2,352.063a.309.309,0,0,0-.437,0,.958.958,0,0,1-.361.257.309.309,0,1,0,.182.59,1.568,1.568,0,0,0,.616-.411A.309.309,0,0,0,369.2,352.063Z"
                transform="translate(-368.188 -351.973)"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgWrapper>
  );
};

export default SesameIcon;
